// import firebase from "firebase/app";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
//import admin from "firebase-admin";
import "firebase/auth";
import "firebase/firestore";
// import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBizIVShq-oqNh7EntXqcS9sC7wYPLnbm0",
  authDomain: "waiora-tamariki.firebaseapp.com",
  projectId: "waiora-tamariki",
  storageBucket: "waiora-tamariki.appspot.com",
  messagingSenderId: "583506478446",
  appId: "1:583506478446:web:530107b7c3ea08e5c36d7f",
  measurementId: "G-F0028F64YD",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
//export const analytics = getAnalytics(firebaseApp);
// firebase.initializeApp(config);

export default firebaseApp;

/**
 * Emulator config
 */
//firebase.functions().useEmulator("localhost", 5001);
//var db = firebase.firestore();
// //eslint-disable-next-line no-restricted-globals
// if (location.hostname === "localhost") {
// 	db.useEmulator("localhost", 8080);
// }
